import { render, staticRenderFns } from "./TerminalScrollArrows.vue?vue&type=template&id=c05783e4&scoped=true"
import script from "./TerminalScrollArrows.vue?vue&type=script&lang=js"
export * from "./TerminalScrollArrows.vue?vue&type=script&lang=js"
import style0 from "./TerminalScrollArrows.vue?vue&type=style&index=0&id=c05783e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05783e4",
  null
  
)

export default component.exports